import { Navigate } from 'react-router-dom';
import { isAgentEnabledFor } from '../agents/agentAccess.ts';
import { getLastAgent } from '../agents/preferences.ts';
import { useAuth } from '../auth/useAuth.ts';
import Hero from '../components/Hero.tsx';

/**
 * Home route gate. Signed-in users are forwarded to the agent they last used
 * (or the chooser if they have none yet); everyone else gets the marketing
 * home. Rendering Hero while auth is still `initializing` avoids blanking the
 * public landing page — the redirect only fires once status is `authenticated`.
 * The last-agent shortcut is eligibility-checked per user (FR-ACCESS-1): a
 * remembered agent this user can no longer enter falls back to the chooser
 * instead of bouncing them into a guard redirect.
 */
export default function HomeRoute() {
  const { status, user } = useAuth();

  if (status === 'authenticated') {
    const last = getLastAgent();
    const target = last !== null && isAgentEnabledFor(last, user) ? `/agent/${last}` : '/app';
    return <Navigate to={target} replace />;
  }

  return <Hero />;
}
